import React from 'react';
import { Dropdown as ADropdown, Menu } from 'antd';

class Dropdown extends React.Component {
  render() {
    const { overlay, ...rest } = this.props;
    return <ADropdown overlay={<Menu>{overlay}</Menu>} {...rest} />;
  }
}

export default Dropdown;
